<template>
    <div :class="['overlay', menuItems ? 'overlay_isMenu' : '']" @keydown.esc="$emit('closeMenu')" @keydown="checkKeyEvent">
        <div class="overlay-inner">
            <button v-focus class="overlay-inner-close vr_2" @click="$emit('closeMenu')" ref="closeButton">
                <div class="visuallyHide_mobile vr_4">
                    Close
                </div>
                <i class="icon icon_closingX"></i>
            </button>
            <div class="menuStack">
                <div class="menuStack-bd">
                    <div class="menuStack-bd-regionSelector" v-if="regionsEnabled">
                        <div class="regionSelector">
                            <label class="regionSelector-label" for="RegionSelector">
                                <span class="isVisuallyHidden">Region Selector</span>
                                <form method="POST" :action="regionAction">
                                    <select class="regionSelector-label-element" name="regionId" id="RegionSelector" onchange="this.form.submit()">
                                        <option v-for="region in regions" :value="region.value" :key="region.value" :selected="isSelected(region)">{{region.name}}</option>
                                    </select>
                                </form>
                                <div class="regionSelector-label-icon">
                                    <i class="icon icon_globe"></i>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div class="menuStack-bd-mainmenu">
                        <div class="menu" @mouseleave="resetMenu">
                        <!-- <div class="menu"> -->
                            <transition-group
                                appear
                                tag="ul" 
                                :class="['menu-list', { noSelectedItem: !activeMenuItem}]"
                                role="navigation"
                                name="v-staggerList"
                                v-if="menuIsOpen"
                                @before-enter="beforeEnter"
                                @enter="enter"
                                >
                                <li v-for="(item,index) of menuItemsStored" :class="['menu-list-item', { isActive: item.isOpen}, item.expandUp ? 'menu-list-item_expandUp' :'' ]" :key="item.text" :data-index="index" @mouseover="openSubmenu($event, index)">
                                    <a v-if="item.children.length > 0" :href="item.link" :target="item.newWindow ? '_blank' : null" @click="openSubmenu($event, index)" role="menuitem" :aria-expanded="item.isOpen.toString()">{{item.text}}</a>
                                    <a v-else :href="item.link" :target="item.newWindow ? '_blank' : null" @click="openSubmenu($event, index)" role="link" style="cursor: pointer">{{item.text}}</a>
                                    <div class="menu">
                                        <transition-group
                                            appear
                                            tag="ul" 
                                            class="menu-list"
                                            role="submenu"
                                            name="v-staggerList"
                                            v-if="item.isOpen && item.children.length > 0"
                                            @before-enter="beforeEnter"
                                            @enter="enter"
                                            >
                                            <li v-for="(item,index) of item.children" class="menu-list-item" :key="item.text" :data-index="index">
                                                <a :href="item.link" :target="item.newWindow ? '_blank' : null">{{item.text}}</a>
                                            </li>
                                        </transition-group>
                                    </div>
                                </li>
                            </transition-group>
                        </div>
                    </div>
                </div>
                <div class="menuStack-ft">
                    <div class="menuStack-ft-social" key="socialLinks" >
                        <social-links v-bind="{socialLinks}" orientation="vertical"></social-links>
                    </div>
                    <div class="menuStack-ft-secondaryMenu" key="secondaryMenu">
                        <secondary-menu v-bind="{secondaryMenuItems}" ></secondary-menu>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SecondaryMenu from './SecondaryMenu.vue';
import SocialLinks from '../common/SocialLinks.vue'
import FocusTrap from '../mixins/FocusTrap';

import {debounce} from '../../utilities/debounce.js'

export default {
    props: ['closeMenu', 'menuItems', 'menuIsOpen', 'secondaryMenuItems', 'socialLinks', 'regionsEnabled', 'regions', 'regionAction'],
    mixins: [FocusTrap],
    data() {
        return {
            menuItemsStored: [],
            activeMenuItem: false
        };
    },
    created() {
        this.menuItemsStored = this.menuItems;

        // close all menus
        this.menuItemsStored.map(el => el.isOpen = false);
    },
    computed: {
        isDesktop() {
            return this.$root.windowWidth > 1024;
        }
    },
    methods: {
        isSelected(region) {
            var regionId = null;
            var value = "; " + document.cookie;
            var parts = value.split("; user_region=");
            if (parts.length == 2){
                regionId = parts.pop().split(";").shift();
            }

            return regionId == region.value;
        },
        openSubmenu(event, index) {
            // clear all isOpen states unless clicking on already open submenu
            this.menuItemsStored.map((el,ind) => el.isOpen = false);

            //return early if clicked element is just a link, no submenu
            if (this.menuItemsStored[index].children.length < 1) {
                return
            }

            // if a submenu, prevent navigation
            event.preventDefault();

            // toggle isOpen at index
            this.menuItemsStored[index].isOpen = !this.menuItemsStored[index].isOpen;

            if (this.menuItemsStored.some((el) => el.isOpen === true)) {
                // console.log("a menu item is open");
                this.activeMenuItem = true;
            } else {
                // console.log("all items are closed");
                this.activeMenuItem = false;
            }
        },
        resetMenu() {
            // clear all isOpen states unless clicking on already open submenu
            this.menuItemsStored.map(el => el.isOpen = false);
            this.activeMenuItem = false;
        },
        beforeEnter: function (el) {
            el.style.transition = "all 400ms";
            el.style.transform = "translateX(-16px)"
            el.style.opacity = 0;
        },
        enter: function (el, done) {
            var delay = el.dataset.index * 100 + 200;
            setTimeout(function () {
                el.style.opacity = 1;
                el.style.transform = "translateX(0)";
            }, delay)
        },
    },
    components: {
        SecondaryMenu,
        SocialLinks
    }
}
</script>

<style lang="scss">
</style>